import React, { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const DataGridContext = /*#__PURE__*/React.createContext(null);
export function DataGridProvider({
  children,
  activeRow
}) {
  const data = useMemo(() => ({
    activeRow
  }), [activeRow]);
  return /*#__PURE__*/_jsx(DataGridContext.Provider, {
    value: data,
    children: children
  });
}